<template>
	<van-tabbar v-if="show" v-model="active" active-color="#e3bf76" :border="false" inactive-color="#9f927b">
		<van-tabbar-item v-for="(k, key) in item" :key="key" @click="navigate(k)">
			<span>{{ getNavTitle(k) }}</span>
			<template #icon="props">
				<span v-if="k.taskEntry" class="vote-gamepad" :class="{ active: props.active }">🎮</span>
				<img v-else width="22" height="22" :src="props.active ? k.icon.active : k.icon.noactive" :alt="k.title"  />
			</template>
		</van-tabbar-item>
	</van-tabbar>
</template>

<script>
export default {
	data() {
		return {
			show: false,
			active: 0,
			loadingTask: false,
			item: [
				{
					router: '/Home',
					title: this.$t('common.homenav'),
					icon: {
						active: '/img/footer/home-active.png',
						noactive: '/img/footer/home.png'
					}
				},
				{
					router: '/Video',
					title: this.$i18n.locale === 'en' ? 'Video' : this.$t('video.title'),
					icon: {
						active: '/img/footer/foot2-active.png',
						noactive: '/img/footer/foot2.png'
					}
				},
				{
					router: '/Game',
					taskEntry: true,
					title: 'Vote',
					icon: {
						active: '/img/footer/foot4-active.png',
						noactive: '/img/footer/foot4.png'
					}
				},
				// {
					
				// 	router: '/pl',
				// 	title: this.$t('common.pinglunnav'),
				// 	icon: {
				// 		active: '/img/footer/foot4-active.png',
				// 		noactive: '/img/footer/foot4.png'
				// 	}
				// },
				{
					router: '/Mine',
					title: this.$t('common.minenav'),
					icon: {
						active: '/img/footer/mine-active.png',
						noactive: '/img/footer/mine.png'
					}
				}
			]
		};
	},
	methods: {
		getNavTitle(item) {
			if (item.router === '/Home') return this.$t('common.homenav');
			if (item.router === '/Video') return this.$t('videoNavLabel');
			if (item.taskEntry) return this.$t('voteAction');
			if (item.router === '/Mine') return this.$t('common.minenav');
			return item.title || '';
		},
		navigate(item) {
			if (item.taskEntry) {
				this.openFirstTask();
				return;
			}
			if (this.$route.path !== item.router) this.$router.replace(item.router);
		},
		async openFirstTask() {
			if (this.loadingTask) return;
			if (!localStorage.getItem('token')) {
				this.$router.push('/Login');
				return;
			}
			this.loadingTask = true;
			try {
				let response = await this.$http({ method: 'get', url: 'lottery_hot' });
				let tasks = Array.isArray(response.data) ? response.data : [];
				if (!tasks.length) {
					response = await this.$http({ method: 'get', url: 'lottery_list' });
					tasks = Array.isArray(response.data) ? response.data : [];
				}
				const task = tasks.find(entry => entry && entry.id && entry.key);
				if (!task) {
					this.$toast(this.$t('common.nodata'));
					return;
				}
				this.$router.push({ path: '/Lottery', query: { key: task.key, id: task.id } });
			} catch (error) {
				this.$toast(this.$t('common.networkError'));
			} finally {
				this.loadingTask = false;
			}
		}
	},
	watch: {
		$route(to) {
			if (to.name == 'home') {
				this.active = 0;
				this.show = true;
			} else if (to.name == 'video') {
				this.active = 1;
				this.show = true;
			} else if (to.name == 'game') {
				this.active = 2;
				this.show = true;
			} else if (to.path === '/pl' || to.name === 'pl') {
				// 修改这里：检查 /pl 页面
				this.active = 3;
				this.show = true;
			} else if (to.name == 'mine') {
				this.active = 3;
				this.show = true;
			} else {
				this.show = false;
			}
		}
	},
	created() {
		const currentRoute = this.$route;
		if (currentRoute.name == 'home') {
			this.active = 0;
			this.show = true;
		} else if (currentRoute.name == 'video') {
			this.active = 1;
			this.show = true;
		} else if (currentRoute.name == 'game') {
			this.active = 2;
			this.show = true;
		} else if (currentRoute.path === '/pl' || currentRoute.name === 'pl') {
			// 修改这里：检查 /pl 页面
			this.active = 3;
			this.show = true;
		} else if (currentRoute.name == 'mine') {
			this.active = 3;
			this.show = true;
		} else {
			this.show = false;
		}
	}
};
</script>

<style lang="less" scoped>
@tabbar-height: 3.5rem;
@tabbar-img: 1.4rem;
.van-tabbar {
	left: 50%;
	width: 100%;
	max-width: 26.875rem;
	height: calc(@tabbar-height + env(safe-area-inset-bottom));
	padding-right: env(safe-area-inset-right);
	padding-bottom: env(safe-area-inset-bottom);
	padding-left: env(safe-area-inset-left);
	transform: translateX(-50%);
	border-top: 1px solid rgba(218, 180, 105, 0.34);
	background: linear-gradient(180deg, rgba(10, 13, 18, 0.97), rgba(4, 6, 9, 0.99));
	box-shadow: 0 -12px 35px rgba(0, 0, 0, 0.45);
	overflow: hidden;
}
.van-tabbar-item__icon img {
	height: @tabbar-img;
	filter: sepia(1) saturate(0.9) hue-rotate(355deg) brightness(1.15);
}
.vote-gamepad {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 1.6rem;
	height: 1.4rem;
	font-size: 1.45rem;
	line-height: 1;
	filter: grayscale(0.15) saturate(0.9);
	transition: transform 0.2s ease, filter 0.2s ease;
}
.vote-gamepad.active {
	transform: translateY(-1px) scale(1.08);
	filter: none;
}
.van-tabbar-item {
	min-width: 0;
	padding: .25rem .2rem;
	font-size: 1rem;
	background: transparent;
	letter-spacing: 1px;
	transition: color 0.25s ease, transform 0.25s ease;
}
.van-tabbar-item span {
	display: block;
	max-width: 100%;
	line-height: 1.2;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.van-tabbar-item--active {
	background: linear-gradient(180deg, rgba(218, 180, 105, 0.09), transparent);
	transform: translateY(-1px);
}
.van-tabbar-item--active::before {
	content: '';
	position: absolute;
	top: 0;
	left: 28%;
	right: 28%;
	height: 2px;
	border-radius: 2px;
	background: linear-gradient(90deg, transparent, #e5c47c, transparent);
}
.tui {
	width: 4rem;
	margin-top: -10.333vw;
	background-color: white;
	border-radius: 50%;
	border: 10px solid white;
	z-index: 10;
}
[class*='van-hairline']::after {
	border: none !important;
}

@media (max-width: 430px) {
	.van-tabbar-item {
		font-size: clamp(.72rem, 3.4vw, .9rem);
		letter-spacing: 0;
	}

	.van-tabbar-item__icon {
		margin-bottom: .15rem;
	}
}

@media (max-width: 340px) {
	.van-tabbar-item {
		padding-inline: .1rem;
		font-size: 11px;
	}

	.van-tabbar-item__icon img {
		width: 1.25rem;
		height: 1.25rem;
	}

	.vote-gamepad {
		font-size: 1.25rem;
	}
}
</style>
